import type { ReactNode } from "react";
import { VerifiedViewer } from "@/session/product-session";
import type { ResourceViewer } from "../resource-reader";
import "../results.css";

export function ResultsFrame({
  children,
  viewer,
}: {
  readonly children: ReactNode;
  readonly viewer: ResourceViewer;
}) {
  return (
    <main id="main" tabIndex={-1} className="softmax-results-content">
      {viewer ? (
        <VerifiedViewer viewer={viewer}>{children}</VerifiedViewer>
      ) : (
        children
      )}
    </main>
  );
}
